import { Howl } from 'howler';

import { config } from '@~/config';

import { Alarm } from './types';

const alarmSound = new Howl({
  src: [require('./alarm.mp3')],
  loop: true,
  preload: true,
  html5: true,
  volume: config.appEnv === 'prod' ? 1 : 0.4,
  onplayerror: () => {
    alarmSound.once('unlock', () => {
      alarmSound.play();
    });
  },
});

export const alarm: Alarm = {
  play: async () => {
    alarmSound.stop();
    alarmSound.play();
  },
  stop: () => {
    alarmSound.stop();
  },
  isPlaying: () => {
    return alarmSound.playing();
  },
};
